import { render, staticRenderFns } from "./recursive-table.vue?vue&type=template&id=1c5ab159&scoped=true&"
import script from "./recursive-table.vue?vue&type=script&lang=js&"
export * from "./recursive-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ab159",
  null
  
)

export default component.exports